module.exports = __webpack_public_path__ + "img/4.b5b1ee23.png";